import auth_404 from "../../assets/img/auth-404.svg"

const Notfound = () => {
  return (
    <div style={{height:'80%'}}>
     <div className="col-12 text-center  mt-5 mb-4">
      <img src={auth_404} className="w240 mb-4" alt="" />
      <h1 className="display-1">404</h1>
      <h5>OOP! PAGE NOT FOUND</h5>
      <span className="text-muted">Sorry, the page you're looking for doesn;t exist. if you think something is brlken, report Link problem.</span>
    </div>
    </div>
  );
};

export default Notfound;
